import { render, staticRenderFns } from "./SelectForm.vue?vue&type=template&id=006b0f7c"
import script from "./SelectForm.vue?vue&type=script&lang=js"
export * from "./SelectForm.vue?vue&type=script&lang=js"
import style0 from "./SelectForm.vue?vue&type=style&index=0&id=006b0f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports